<template>
	<div>
		<vendor-sign-up-modal
			:vendorAccount="vendorDetails"
			:show="show"
			:showPassword="showPassword"
			:viewOrEdit="viewOrEdit"
			:fieldNotEditable="fieldNotEditable"
			v-if="openVendorSignUpModal"
			@updateVendorInfo="vendorSignUpDataUpdate($event)"
			@vendorSignUpModalClose="vendorSignUpModalClose"
		>
		</vendor-sign-up-modal>
		<div class="dashboard-card">
			<!-- tag -->
			<div
				class="dashbord-tag failed"
				:style="(getStatusData.request_status ==='REQUEST ACCEPTED')?
         '    background-color: green;':
         (getStatusData.request_status ==='REQUEST PROCESSING')?
         '    background-color: yellow;color:black;':
         '    background-color: red;'"
				data-test="vendorDetailsDashboardStatus"
			>
				{{(getStatusData.request_status ==='REQUEST ACCEPTED')?
				'Verified':
				(getStatusData.request_status ==='REQUEST PROCESSING')?
				'Unverified':
				'Verification Failed'}}
			</div>
			<!-- tag -->
			<div class="card-details">
				<p data-test="vendorDetailsDashboardNameLabel"
							id="vendorDetailsDashboardNameLabel">
					Name:
					<span data-test="vendorDetailsDashboardName"
											id="vendorDetailsDashboardName">
            {{vendorDetails.firstname+' '+vendorDetails.lastname}}
          </span>
				</p>
				<p data-test="vendorDetailsDashboardAddressLabel"
							id="vendorDetailsDashboardAddressLabel">
					Address:
					<span data-test="vendorDetailsDashboardAddress"
											id="vendorDetailsDashboardAddress">
            {{vendorDetails.address_line1}} {{vendorDetails.address_line2}}
          </span>
				</p>
				<p data-test="vendorDetailsDashboardPhnLabel"
							id="vendorDetailsDashboardPhnLabel">
					Phone:
					<span data-test="vendorDetailsDashboardPhn"
											id="vendorDetailsDashboardPhn">{{vendorDetails.phone_number}}</span>
				</p>
				<p data-test="vendorDetailsDashboardEmailLabel"
							id="vendorDetailsDashboardEmailLabel">
					Email:
					<span data-test="vendorDetailsDashboardEmail"
											id="vendorDetailsDashboardEmail">{{vendorDetails.vendor_email}}</span>
				</p>
			</div>
			<!-- action -->
			<div class="card-actions">
				<a
					type="button"
					class="btn btn-primary"
					@click.prevent="variableEdit"
					data-test="vendorDetailsDashboardEditLink"
					id="vendorDetailsDashboardEditLink"
				>
					Edit
				</a>
				<a
					type="button"
					class="btn btn-primary"
					@click.prevent="variableView"
					data-test="vendorDetailsDashboardViewLink"
					id="vendorDetailsDashboardViewLink"
				>
					View
				</a>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import VendorSignUpModal from '../../modals/vendorSignUpModal'
import { vendorApis } from '../../../../../services/ApiServices/vendorApis'

export default {
	components: { VendorSignUpModal },
	name: 'vendor-details-dashboard',
	computed: {
		...mapGetters('vendor', ['getStatusData'])
	},
	mounted () {
		this.vendorInfoDetails()
	},
	data () {
		return {
			vendorDetails: {},
			show: '',
			viewOrEdit: 'true',
			showPassword: false,
			openVendorSignUpModal: false,
			fieldNotEditable: false
		}
	},
	methods: {
		vendorSignUpDataUpdate (updatedAccount) {
			vendorApis.vendorInfoUpdate(updatedAccount).then(() => {
				$('#SignupModal').modal('hide')
				this.vendorInfoDetails()
			})
		},
		vendorInfoDetails () {
			vendorApis.vendorInfo()
				.then((res) => {
					this.vendorDetails = res.data
					this.vendorDetails.username = res.data.user_name
					this.vendorDetails.email = res.data.vendor_email
				})
		},
		variableEdit () {
			this.viewOrEdit = 'edit'
			this.show = false
			this.fieldNotEditable = false
			this.vendorSignUpFormOpenAndClose('show', true)
		},
		variableView () {
			this.viewOrEdit = 'view'
			this.show = true
			this.vendorSignUpFormOpenAndClose('show', true)
		},
		vendorSignUpFormOpenAndClose (modalAction, componentShow) {
			this.openVendorSignUpModal = componentShow
			this.$nextTick(() => {
				$('#SignupModal').modal(modalAction)
			})
		},
		vendorSignUpModalClose () {
			this.viewOrEdit = ''
			this.show = true
			this.vendorInfoDetails()
			this.vendorSignUpFormOpenAndClose('hide', true)
		}
	}
}
</script>

<style scoped>
</style>
